import { SelectObjectInput, useField } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { DefaultOptionType } from 'antd/es/select';
import { useCallback } from 'react';
import { IWidgetComponentProps } from '../../../../IWidgetType';
import { useSelectOptions } from '../../common/option-list/hooks/useSelectOptions';
import { getWidgetProps } from '../../common/util/getWidgetProps';
import { IMultiSelectWidget } from '../../multi-select/IMultiSelectWidget';
import { multiSelectOptionsObjectName } from '../getMultiSelectOptionsObjectName';
import { IUseMultiSelectWidgetOptionsReturn } from './hooks/useMultiSelectWidgetOptions';

export interface IMultiSelectSelectComponentProps
  extends IWidgetComponentProps<IMultiSelectWidget>,
    IUseMultiSelectWidgetOptionsReturn {}

/**
 * Componente principale del widget select in caso di scelta di menù a tendina.
 */
export function MultiSelectSelectComponent(
  props: IMultiSelectSelectComponentProps,
) {
  const { widget, options, componentOptions } = props;
  const { t } = useTranslation();

  const widgetOptions = getWidgetProps(props);

  const optionsName = multiSelectOptionsObjectName(widgetOptions.name);

  const selectOptions = useSelectOptions(componentOptions, widgetOptions);

  // Quando viene selezionata una opzione, aggiorniamo direttamente nel
  // form il valore del campo.
  // Questo è fondamentale, altrimenti il valore non viene aggiornato e
  // la validazione fallisce.
  const groupFieldName = widgetOptions.name;
  const group = useField(groupFieldName);
  const groupSetValue = group.setValue;

  const handleChange = useCallback(
    (
      value: any[],
      options: DefaultOptionType | DefaultOptionType[] | undefined,
      onChange: (value: any[]) => void,
    ) => {
      groupSetValue(value, { shouldTouch: false, shouldDirty: false });
      onChange(value);
    },
    [groupSetValue],
  );

  return (
    <SelectObjectInput
      readOnly={props.readonly}
      mode="multiple"
      registerAsRef={groupFieldName}
      name={optionsName}
      options={selectOptions}
      optionFilterProp="labelText"
      onChange={handleChange}
      allowClear
      rootClassName="full-text-options"
      placeholder={
        widgetOptions.placeholder
          ? widgetOptions.placeholder
          : widgetOptions.preview
          ? t(
              'widgets.multi-select-select-component.placeholder',
              'Placeholder',
            )
          : ''
      }
      showSearch={true}
    />
  );
}
